export { default } from './TreeView';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TreeView/index.js
// module id = 905
// module chunks = 2